<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "ResetRealityModal",
  components: {
    ModalWrapperChoice
  },
  data() {
    return {
      isDoomed: false,
      canReality: false,
    };
  },
  computed: {
    resetTerm() { return this.isDoomed ? "Армагеддон" : "Реальность"; },
  },
  methods: {
    update() {
      this.isDoomed = Pelle.isDoomed;
      this.canReality = isRealityAvailable();
    },
    handleYesClick() {
      beginProcessReality(getRealityProps(true));
      EventHub.ui.offAll(this);
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="resetReality"
    @confirm="handleYesClick"
  >
    <template #header>
      Вы собираетесь сбросить {{ resetTerm }}
    </template>
    <div class="c-modal-message__text">
      Это сбросит вернёт вас к началу {{ resetTerm == "Армагеддон" ? "Армагеддона" : "Реальности" }},
      лишив вас награды за текущий прогресс в {{ resetTerm == "Армагеддон" ? "Армагеддоне" : "Реальности" }}.
      <br>
      <br>
      Вы уверены, что хотите сделать это?
      <div
        v-if="canReality"
        class="c-has-rewards"
      >
        <br>
        У вас есть возможность завершить Реальность для получения наград, однако вы не получите их, если
        Сбросите здесь. Чтобы получить награды, используйте кнопку "Сделать новую Реальность".
      </div>
      <br>
    </div>
    <template #confirm-text>
      Сбросить
    </template>
  </ModalWrapperChoice>
</template>

<style scoped>
.c-has-rewards {
  font-weight: bold;
  font-size: 1.5rem;
  color: var(--color-bad);
}
</style>
